import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './MergeSuggestionsPanel.css';

const SRC = {
  AZURE_AD: { label: 'Azure AD', color: '#0078d4', icon: 'fa-microsoft' },
  AWS_IAM:  { label: 'AWS IAM',  color: '#ff9900', icon: 'fa-aws' },
  GITHUB:   { label: 'GitHub',   color: '#24292e', icon: 'fa-github' },
  GOOGLE:   { label: 'Google',   color: '#4285f4', icon: 'fa-google' },
};

function chip(source) {
  const m = SRC[source] || { label: source, color: '#64748b', icon: 'fa-user' };
  return (
    <span className="ms-chip" style={{ background: m.color + '1a', color: m.color, border: `1px solid ${m.color}33` }}>
      <i className={`fab ${m.icon}`} /> {m.label}
    </span>
  );
}

function acct(identity) {
  if (!identity) return null;
  return (
    <div className="ms-acct">
      <span className="ms-acct-name">{identity.displayName || identity.email || '—'}</span>
      <span className="ms-acct-meta">
        {chip(identity.source)}
        {identity.email && <span className="ms-acct-email">{identity.email}</span>}
      </span>
    </div>
  );
}

/**
 * T-0328 Part 3 — surfaces PENDING duplicate-person suggestions with a human confirm / keep-separate
 * decision. Nothing is ever merged automatically; this panel is the only path to a merge.
 */
function MergeSuggestionsPanel({ suggestions, busyId, onConfirm, onReject }) {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="ms-panel">
      <div className="ms-head" onClick={() => setCollapsed(c => !c)}>
        <div className="ms-head-left">
          <i className="fas fa-people-arrows ms-head-icon" />
          <span className="ms-head-title">
            {t('PeoplePage.suggestTitle', {
              count: suggestions.length,
              defaultValue: '{{count}} possible duplicate people found across your identity sources',
            })}
          </span>
        </div>
        <i className={`fas ${collapsed ? 'fa-chevron-down' : 'fa-chevron-up'} ms-head-caret`} />
      </div>

      {!collapsed && (
        <div className="ms-body">
          <p className="ms-hint">
            {t('PeoplePage.suggestHint', {
              defaultValue:
                'These accounts look like the same human, matched only on a weak signal. Confirm to link them into one person, or keep them separate. Nothing is merged until you confirm.',
            })}
          </p>
          {suggestions.map(s => {
            const busy = busyId === s.id;
            return (
              <div className="ms-row" key={s.id}>
                <div className="ms-pair">
                  {acct(s.identityA)}
                  <i className="fas fa-link ms-link-icon" />
                  {acct(s.identityB)}
                </div>
                <div className="ms-actions">
                  <button className="ms-btn ms-confirm" disabled={busy} onClick={() => onConfirm(s.id)}>
                    {busy
                      ? <i className="fas fa-spinner fa-spin" />
                      : <><i className="fas fa-check" /> {t('PeoplePage.suggestConfirm', { defaultValue: 'Same person' })}</>}
                  </button>
                  <button className="ms-btn ms-reject" disabled={busy} onClick={() => onReject(s.id)}>
                    <i className="fas fa-times" /> {t('PeoplePage.suggestReject', { defaultValue: 'Keep separate' })}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default MergeSuggestionsPanel;
